module.exports = __webpack_public_path__ + "img/flag-FR.a7d33e19.png";